import { makeAutoObservable, observable, action } from 'mobx';
import * as ViewModel from '@/core/presenter/viewModel';
import { IPresentationStore } from './types';
import { IResponseBalance } from '@/core/domain/entities/user';
import { IRequestCondition } from '@/core/domain/entities/request';

export default class PresentationStore implements IPresentationStore {
  @observable private _transactions: ViewModel.IResponseActivity[] = [];
  @observable private _tokenTransactions: ViewModel.IResponseActivity[] = [];
  @observable private _tokenPrice: number | undefined;
  @observable private _trxPrice: number | undefined;
  @observable private _fee: number | undefined;
  @observable private _balance: IResponseBalance = {
    trxBalance: 0,
    trxKRW: 0,
    tokenBalance: 0,
    tokenKRW: 0,
    tokenPrice: 0,
    trxPrice: 0,
    address: '',
    dbsBuyCount: 0,
    dbsBuyCountKRW: 0,
  };
  @observable private _transferData: IRequestCondition | null = null;
  @observable private _phoneNumber: string = '';

  constructor() {
    makeAutoObservable(this, {}, { deep: true });
  }

  public get transactions(): ViewModel.IResponseActivity[] {
    return this._transactions;
  }

  public get tokenTransactions(): ViewModel.IResponseActivity[] {
    return this._tokenTransactions;
  }

  public get tokenPrice(): number | undefined {
    return this._tokenPrice;
  }

  public get trxPrice(): number | undefined {
    return this._trxPrice;
  }

  public get fee(): number | undefined {
    return this._fee;
  }

  public get balance(): IResponseBalance {
    return this._balance;
  }

  public get transferData(): IRequestCondition | null {
    return this._transferData;
  }

  public get phoneNumber(): string {
    return this._phoneNumber;
  }

  public setTokenTransactions(transactions: ViewModel.IResponseActivity[]): void {
    this._tokenTransactions = transactions;
  }

  public setTransactions(transactions: ViewModel.IResponseActivity[]): void {
    this._transactions = transactions;
  }

  public setTokenPrice(price: number): void {
    this._tokenPrice = price;
  }

  public setTrxPrice(price: number): void {
    this._trxPrice = price;
  }

  public setFee(fee: number): void {
    this._fee = fee;
  }

  public setTransferData(data: IRequestCondition | null): void {
    this._transferData = data;
  }

  public setPhoneNumber(phoneNumber: string): void {
    this._phoneNumber = phoneNumber;
  }

  @action
  public setBalance(balance: IResponseBalance): void {
    this._balance = { ...this._balance, ...balance };
  }

  @action
  public clearStoreData(): void {
    this._transactions = [];
    this._tokenTransactions = [];
    this._tokenPrice = undefined;
    this._trxPrice = undefined;
    this._fee = undefined;
    this._balance = {
      trxBalance: 0,
      trxKRW: 0,
      tokenBalance: 0,
      tokenKRW: 0,
      tokenPrice: 0,
      trxPrice: 0,
      address: '',
      dbsBuyCount: 0,
      dbsBuyCountKRW: 0,
    };
    this._transferData = null;
    this._phoneNumber = '';
  }
}
